
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import Candidate, { UpdateCandidate } from "@/lib/model/exam/candidate";
import ModalTitle from "@/lib/model/exam/modal-title";

@Component({
  components: {
    ModalHeader
  }
})
export default class EditCandidateModal extends Vue {
  @Prop() private updateCandidateForm!: UpdateCandidate;
  //   @Prop({ type: String })
  //   examName!: string;
  @Prop() private examName!: string;
  @Prop() private isVisible!: boolean;
  name = "edit-candidate";
  modalTitle = new ModalTitle();
  isShowAddOne = false;

  mounted() {
    this.modalTitle.title = "编辑候选人";
    this.modalTitle.hasDesc = true;
    this.modalTitle.desc = this.examName;
  }

  @Emit("on-add-cancel")
  addCancel() {
    return false;
  }

  @Emit("on-add-submit")
  onAddSubmit() {
    return false;
  }

  addSubmit() {
    this.updateCandidateForm.showName = this.updateCandidateForm.paramList[0]
      .value
      ? this.updateCandidateForm.paramList[0].value
      : "";
    this.updateCandidateForm.phone = this.updateCandidateForm.paramList[1].value
      ? this.updateCandidateForm.paramList[1].value
      : "";
    Candidate.updateCandidate(this.updateCandidateForm).then(res => {
      if (res.code === 0) {
        this.onAddSubmit();
        // this.isShowAddOne = false;
      } else {
        this.$message.error(res.message);
      }
    });
  }

  @Emit("on-close-one")
  handleClose() {
    console.log("on-close-one");
  }
}
